'use strict';
module.exports = require('./Accordion.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/accordion/index.js
// module id = 95
// module chunks = 7